module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/normalize-wheel/index.js
// module id = 555
// module chunks = 0